module.exports = __webpack_public_path__ + "img/img-2mobile.9446ff82.webp";